import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { I18nextProvider } from 'react-i18next';

import App from './App';

// Import locales
import i18n from './i18n';

const base = window.location.protocol + '//' + window.location.host;

ReactDOM.render(
  <I18nextProvider i18n={ i18n }>
    <div>
      <base href={base} target='_blank' />
      <App />
    </div>
  </I18nextProvider>
  , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js